import React from 'lib/react';
import {
  EVGrid, EVPaper, EVSkeleton, EVTypography, makeStyles,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import { useSelector } from 'lib/redux';
import { getReportCountText } from '../OrderHistory.utils';
import Filters from './filters';

const useStyles = makeStyles((theme) => ({
  filtersRow: {
    '@media (min-width: 640px)': {
      padding: '16px 24px',
    },
  },
  filtersContainer: {
    backgroundColor: theme.evPalette.charcoal[200],
    padding: '8px',
    boxShadow: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '8px',
    borderRadius: '0px',
    '@media (min-width: 640px)': {
      alignItems: 'center',
      flexDirection: 'row',
      borderRadius: '4px',
    },
  },
  reportCount: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.evPalette.charcoal[800],
  },
  refineResults: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
    color: theme.evPalette.charcoal[800],
  },
}));

function FiltersRow() {
  const classes = useStyles();
  const { t } = useTranslation();
  const myevRefreshFiltersFeatureFlag = useSelector(({ featureFlag }) => featureFlag.myevRefreshFilters);

  const {
    loading, pageNumber, pageSize, reportIds,
  } = useSelector(({ orderHistory }) => orderHistory);

  return (
    <EVGrid className={classes.filtersRow}>
      {loading
        ? <EVSkeleton style={{ borderRadius: '6px' }} height={44} />
        : (
          <EVPaper className={classes.filtersContainer}>
            <EVGrid container direction="column" style={{ gap: '8px', width: 'unset' }}>
              <EVTypography className={classes.reportCount}>{getReportCountText(reportIds, pageNumber, pageSize, t)}</EVTypography>
              {myevRefreshFiltersFeatureFlag && <EVTypography className={classes.refineResults}>{t('order_history__refine_results')}</EVTypography>}
            </EVGrid>
            {myevRefreshFiltersFeatureFlag && <Filters />}
          </EVPaper>
        )}
    </EVGrid>
  );
}

export default FiltersRow;
